import { isNative } from '@/core/platform/runtime'
import { BlobPhotoStorage } from './blobPhotoStorage'
import type { PhotoStorage } from './photoStorage'

/**
 * Factory singleton — resolve uma vez em runtime qual impl usar.
 *
 * Em native, dynamic import do FilesystemPhotoStorage pra que o web build
 * NÃO precise resolver `@capacitor/filesystem` (que não está nas deps em
 * dev). O tree-shaker do Vite mantém só o que cada bundle precisa.
 *
 * Sync vs async: como precisamos do singleton pronto pra usar logo nos
 * componentes (sem await em todo lugar), inicializamos com BlobPhotoStorage
 * default e, em native, substituímos no boot via `initPhotoStorage()` chamado
 * em App.tsx.
 */

let current: PhotoStorage = new BlobPhotoStorage()

export function photoStorage(): PhotoStorage {
  return current
}

export async function initPhotoStorage(): Promise<void> {
  if (!isNative()) {
    // Web: BlobPhotoStorage já é o default. Nada a fazer.
    return
  }
  try {
    const mod = await import('./filesystemPhotoStorage')
    current = new mod.FilesystemPhotoStorage()
    console.info('[storage] FilesystemPhotoStorage ativo (Capacitor native)')
  } catch (err) {
    console.warn('[storage] falha ao carregar FilesystemPhotoStorage, fallback Blob:', err)
  }
}

export type { PhotoHandle, PhotoStorage } from './photoStorage'
